module.exports = __webpack_public_path__ + "img/course73.e69ee55b.png";